import { QueryCache, QueryClient } from '@tanstack/react-query'

import { HttpError } from '@/api/http'

import { CHARGING_POINT_QUERY_KEYS } from '@/api/charging-points/keys'
import { STATION_QUERY_KEYS } from '@/api/stations/keys'
import { AppRoutes } from '@/routes/types/routes'

const STATION_SCOPED_KEYS: string[] = [STATION_QUERY_KEYS.GET_STATION, CHARGING_POINT_QUERY_KEYS.GET_CHARGING_POINT]

let handlingUnavailableStation = false

const queryCache = new QueryCache({
  onError: (error, query) => {
    if (!(error instanceof HttpError)) {
      return
    }
    if (error.status !== 403 && error.status !== 404) {
      return
    }
    if (!STATION_SCOPED_KEYS.includes(query.queryKey[0] as string)) {
      return
    }
    if (query.getObserversCount() === 0) {
      return
    }
    if (handlingUnavailableStation) {
      return
    }

    handlingUnavailableStation = true

    const message = error.status === 403 ? error.message : 'Estação não encontrada.'

    queryClient.invalidateQueries({ queryKey: [STATION_QUERY_KEYS.GET_STATIONS] })

    window.dispatchEvent(
      new CustomEvent('auth:redirect', {
        detail: { url: `${AppRoutes.STATIONS}?error=${encodeURIComponent(message)}` },
      })
    )

    setTimeout(() => {
      handlingUnavailableStation = false
    }, 3000)
  },
})

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      retry: false,
      gcTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  },
})
